import { render, staticRenderFns } from "./SlotStaff.vue?vue&type=template&id=0f38c1ac&scoped=true&"
import script from "./SlotStaff.vue?vue&type=script&lang=js&"
export * from "./SlotStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f38c1ac",
  null
  
)

export default component.exports